import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b79e719"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { style: {"height":"90vh"} }
const _hoisted_3 = { style: {"height":"0.5vh","background-color":"#ccc"} }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = {
  class: "p-col-12 pos-table",
  style: {"height":"72vh","background-color":"#f9f9f9"}
}
const _hoisted_8 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_9 = { class: "pos-heading" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Product Name", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Batch No", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit Qty", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit Disc (%)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "After Disc", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cus Disc %", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry Date", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_21 = { class: "p-pt-2" }
const _hoisted_22 = { class: "p-pt-2" }
const _hoisted_23 = { class: "p-inputgroup" }
const _hoisted_24 = { class: "p-pt-2" }
const _hoisted_25 = { class: "p-pt-2" }
const _hoisted_26 = { class: "p-pt-2" }
const _hoisted_27 = { class: "p-pt-2" }
const _hoisted_28 = { class: "p-pt-2" }
const _hoisted_29 = { class: "p-pt-2" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "p-inputgroup" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "p-inputgroup" }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = { class: "p-text-center" }
const _hoisted_37 = { class: "p-text-center" }
const _hoisted_38 = {
  class: "p-col-12",
  style: {"height":"10vh","background-color":"#eee"}
}
const _hoisted_39 = { class: "p-grid" }
const _hoisted_40 = { class: "p-col-6 p-pr-0" }
const _hoisted_41 = { class: "p-fluid" }
const _hoisted_42 = { class: "p-col-3" }
const _hoisted_43 = { class: "p-fluid" }
const _hoisted_44 = { class: "p-col-3" }
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_47 = { class: "set-bottom-amt p-col" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Total QTY ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { class: "set-bottom-amt p-col" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = { class: "set-bottom-amt p-col" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = { class: "set-bottom-amt p-col" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = { class: "confirmation-content" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_67 = { class: "p-fluid" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search_receipt" }, " Enter Receipt No ", -1))
const _hoisted_69 = { class: "confirmation-content" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_71 = { class: "confirmation-content" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"red"}
}, null, -1))
const _hoisted_73 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.progressBar)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                style: {"height":"0.2em"}
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
          start: _withCtx(() => [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("b", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
              ])
            ])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                icon: "pi pi-minus",
                label: "Search Receipt",
                class: "p-button-danger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (this.receiptDailog = true))
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("th", null, "Unit Purchase Price (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("th", null, "MRP (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_15,
                _hoisted_16,
                (_ctx.taxNames[0].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_17, _toDisplayString(_ctx.taxNames[0].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[1].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.taxNames[1].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[2].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.taxNames[2].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_20
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.state.savedItemList.slice().reverse(), (savedItem) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: savedItem.id,
                  class: "table-row"
                }, [
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.limitString(savedItem.productName)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.limitString(savedItem.batchNo)), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-plus",
                        class: "p-button-success p-p-0",
                        onClick: ($event: any) => (_ctx.adjustQty('add', savedItem))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_InputText, {
                        style: {"width":"2rem","height":"35px"},
                        modelValue: savedItem.unit,
                        "onUpdate:modelValue": ($event: any) => ((savedItem.unit) = $event),
                        modelModifiers: { number: true },
                        class: _normalizeClass(["p-p-0 p-m-0", {'is-invalid': savedItem.unit == 0 || (savedItem.totalPurchacedUnits > savedItem.stockQty) ? savedItem.unit > savedItem.stockQty :  savedItem.unit > savedItem.totalPurchacedUnits }]),
                        onInput: ($event: any) => (_ctx.validateUnit(savedItem, $event))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "class"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-minus",
                        class: "p-button-warning p-p-0",
                        onClick: ($event: any) => (_ctx.adjustQty('minus', savedItem))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("small", null, _toDisplayString(savedItem.purchasePrice.toFixed(2)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("small", null, _toDisplayString(savedItem.itemDisc.toFixed(2)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _createElementVNode("small", null, _toDisplayString(savedItem.purchaseAfterDisc.toFixed(2)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("small", null, _toDisplayString(savedItem.mrp.toFixed(2)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("small", null, _toDisplayString(savedItem.cusDisc.toFixed(2)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.limitString(savedItem.expiryDate)), 1)
                  ]),
                  (_ctx.taxNames[0].show)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_InputNumber, {
                            useGrouping: false,
                            style: {"width":"2rem","height":"30px"},
                            minFractionDigits: 2,
                            maxFractionDigits: 2,
                            modelValue: savedItem.tax1,
                            "onUpdate:modelValue": ($event: any) => ((savedItem.tax1) = $event),
                            class: "p-p-0"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.taxNames[1].show)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_InputNumber, {
                            useGrouping: false,
                            style: {"width":"2rem","height":"30px"},
                            minFractionDigits: 2,
                            maxFractionDigits: 2,
                            modelValue: savedItem.tax2,
                            "onUpdate:modelValue": ($event: any) => ((savedItem.tax2) = $event),
                            class: "p-p-0"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.taxNames[2].show)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_InputNumber, {
                            useGrouping: false,
                            style: {"width":"2rem","height":"30px"},
                            minFractionDigits: 2,
                            maxFractionDigits: 2,
                            modelValue: savedItem.tax3,
                            "onUpdate:modelValue": ($event: any) => ((savedItem.tax3) = $event),
                            class: "p-p-0"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_36, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_37, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-minus",
                      class: "p-button-danger p-p-1",
                      onClick: ($event: any) => (_ctx.clearListItem(savedItem))
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_InputText, {
                  placeholder: "Receipt Description",
                  modelValue: _ctx.item.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.description) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_InputText, {
                  placeholder: "Bill No",
                  modelValue: _ctx.item.billNo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.billNo) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_InputText, {
                  placeholder: "Supplier",
                  modelValue: _ctx.v$.selectedProfile.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createVNode(_component_Button, {
          class: "p-col p-button-success b-style",
          icon: "pi pi-home",
          label: "HOME",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectHome()))
        }),
        _createElementVNode("span", _hoisted_47, [
          _hoisted_48,
          _hoisted_49,
          _createTextVNode(" # " + _toDisplayString(_ctx.state.savedItemList.length), 1)
        ]),
        _createElementVNode("span", _hoisted_50, [
          _hoisted_51,
          _hoisted_52,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
        ]),
        _createElementVNode("span", _hoisted_53, [
          _hoisted_54,
          _hoisted_55,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
        ]),
        (_ctx.taxNames[0].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " ", 1),
              _hoisted_57,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[1].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " ", 1),
              _hoisted_59,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[2].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " ", 1),
              _hoisted_61,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_62, [
          _hoisted_63,
          _hoisted_64,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
        ]),
        _createVNode(_component_Button, {
          class: "p-col p-button-warning b-style",
          icon: "pi pi-arrow-right",
          label: "NEXT",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
          disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.receiptDailog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receiptDailog) = $event)),
      style: { width: '600px' },
      maximizable: true,
      class: "p-fluid",
      modal: true,
      closable: true,
      header: "Search Receipt",
      position: "top"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (this.receiptDailog = false))
        }),
        _createVNode(_component_Button, {
          label: "Search",
          icon: "pi pi-search",
          class: "p-button-success",
          disabled: _ctx.item.searchReceiptNo == '',
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fetchReceiptNo()))
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createVNode(_component_InputText, {
              id: "search_receipt",
              autoFocus: "",
              modelValue: _ctx.item.searchReceiptNo,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.searchReceiptNo) = $event)),
              placeholder: "e.g PUR-02502100000000"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.validationPopup,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.validationPopup) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Close",
          icon: "pi pi-close",
          class: "p-button-danger",
          onClick: _ctx.closeValidationPopup
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
      dialogStatus: _ctx.paymentDialog,
      itemSource: _ctx.item.type,
      restriction: 'No',
      paymentOptionType: 'Cashier',
      cashPayment:this.cashPaymentOption,
      paySupplierCredit:_ctx.paySupplierCredit,
      hideKeyPad:true,
      dialogTitle: 'Purchase Returns',
      customerID: this.item.profileID,
      customerName: this.state.selectedProfile,
      closeConfirmation: true,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.errorDialog,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.errorDialog) = $event)),
      style: { width: '450px' },
      header: "Invalid Data"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.errorDialog = false))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_71, [
          _hoisted_72,
          (this.validationErrors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.validationErrors, (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    style: {"font-size":"1rem"}
                  }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}